export default __webpack_public_path__ + "static/media/categories-features_converted.52e6d391.jpg";